import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_iacash.png",
      alt: "Estratégias IA.CASH",
    },
    title: "Ganhe com a IA.CASH",

    // String ou array de strings
    text: [
      "Com mais de 12 anos de experiencia no mercado com passagem em mesa de instituições financeiras nasceu a IA.CASH. Aqui levamos aos nossos clientes tecnologia de ponta, com robôs criados por inteligência artificial. Venha ser um parceiro com o conhecimento e dedicação de profissionais a favor do seu patrimônio.",
    ],
    testimonial: {
      text: "Estamos transformando o mercado de operações automatizadas",
      author: {
        name: "Gustavo G. Diretor da IA.CASH",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Portifólios IA.CASH",
    heading: "Ganhe dinheiro com nossa tecnologia.",
    subtitle:
      "Com tecnologia de ponta e conhecimento de operadores profissionais temos os mais avançados algoritmos para operar em sua conta, em um clique você se transforma em um profissional. ",
  },

  cta: {
    title: "Quer operar como um profissional?",
    subtitle: "Ative agora mesmo a extensão IA.CASH",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "IA.CASH",
    col1: [
      "Descubra a revolução nos investimentos com nossa empresa líder em tecnologia. Fundada por um Head de mesa de operações no institucional, combinamos inteligência artificial e experiência para criar os robôs mais avançados do mercado financeiro.",
      "Nossa equipe desenvolve algoritmos sofisticados que se adaptam dinamicamente, proporcionando resultados consistentes e lucrativos.",
      "Junte-se a nós e experimente a diferença que a excelência em tecnologia pode fazer em seus investimentos.",
    ],
    // col2: [
    //   "Utilizando estratégias próprias e profissionais ao longo dos anos conseguimos proporcionar aos traders um melhor acompanhamento das movimentações do mercado e com a automatização  conseguimos potencializar performance, gestão de risco e excluir o fator emocional, assim como otimizar o tempo dos nossos traders.",
    // ],
  },

  stats: {
    title: "IA.CASH",
    subtitle:
      "Viva o sonho de ter renda neste mercado com a ajuda do nosso time de profissionais ",
    data: [
      {
        value: "+12",
        description: "Anos de experiência",
      },
      {
        value: "+150",
        description: "Robôs construídos e aprovados",
      },
      {
        value: "+2K",
        description: "Testes de robustez em cada estratégia",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da IA.CASH?",
    subtitle: "Veja quais as principais vantagens dos robôs da IA.CASH",
    data: [
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Você não precisa de conhecimento nenhum para operar como um profissional, basta ligar os algoritmos da IA.CASH com um clique e o resto é com nosso time.",
      },
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Nossos algoritmos são pensados por profissionais e treinados por inteligências artificiais, usamos uma tecnologia de ponta para criar portifólios robustos e que se adaptam ao mercado.",
      },
      {
        icon: iconsSet.favorite,
        title: "Zero emocional",
        description:
          "Com nossos algoritmos você não precisa se preocupar com nada, o maior motivo de prejuízo em operações é o emocional do trader, aqui esse problema é banido. ",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Profissionais de verdade",
        description:
          "A IA.CASH foi criada por operadores de renda variável do Institucional, isso mesmo profissionais que atuam no mercado criando e levando oportunidade para clientes do Brasil inteiro de forma profissional.",
      },
      {
        icon: iconsSet.click,
        title: "Praticidade ",
        description:
          "Todos nossos robõs podem ser ligados em clique, eles já estão prontos para operar em sua conta de forma segura, monitorada por profissionais e com histórico impecável.",
      },
      {
        icon: iconsSet.growth,
        title: "Futuro ",
        description:
          "Nossos produtos já elevaram a vida de uma enorme quantia de clientes, ajudamos as pessoas a, entenderem do mercado, tirarem uma renda extra e até mesmo sonhar com aposentadoria ou uma vida muito melhor",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão IA.CASH",
  },

  testimonials: [
    {
      text: "Como alguém que está apenas começando a explorar o mundo dos investimentos, encontrar uma empresa confiável e inovadora como a IA.CASH foi uma verdadeira bênção. Os robôs de negociação tornaram todo o processo muito mais simples e acessível para mim.",
      author: "Ricardo. C",
      job: "Motorista de aplicativo",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Desde que comecei a utilizar os serviços da IA.CASH, minha experiência de investimento mudou completamente. Os robôs de negociação são incrivelmente eficientes e proporcionaram resultados consistentes para minha carteira. Além disso, a equipe de suporte ao cliente sempre foi ágil e prestativa em responder às minhas dúvidas. Recomendo.",
      author: "Ana Maria",
      job: "Advogada",
      image_url:
        "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],
};
